import React from "react"

import { useImage } from "../../../hooks/useImage"

export const withArticleBanner = Component => ({ name = "ArticleBanner", locales }) => {
  const { getResponsiveImage } = useImage()

  const image = getResponsiveImage(locales?.image, { maxWidth: 2000 })

  Component.displayName = name
  return <Component {...locales} image={image} />
}
